import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { SocialModule } from '@tytapp/social';
import { TYTCommonModule } from '@tytapp/common';
import { CommonUiModule } from '@tytapp/common-ui';
import { AuthGuard, UserModule } from '@tytapp/user';
import { SettingsComponent } from './settings/settings.component';
import { NotificationsSettingsComponent } from './notifications-settings/notifications-settings.component';
import { FormsModule } from '@angular/forms';
import { PrivacyControlsComponent } from './privacy-controls/privacy-controls.component';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { NotificationsCategorySettingsComponent } from './notification-category-settings/notifications-category-settings.component';
import { MembershipAccountComponent } from './membership-account/membership-account.component';
import { CartService } from './cart.service';
import { CommunicationPreferenceComponent } from './communication-preference/communication-preference.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ChangeUsernameComponent } from './change-username/change-username.component';
import { ChangeEmailComponent } from './change-email/change-email.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DeleteUserDataComponent } from '@tytapp/app/pages/settings-pages/delete-user-data/delete-user-data.component';
import { ShowsModule } from '@tytapp/shows';
import { DevModule } from '@tytapp/app/dev';
import { MembershipFeatureComponent } from './membership-feature/membership-feature.component';
import { MembershipFeaturesComponent } from './membership-features/membership-features.component';
import { SponsorshipToolkitComponent } from './sponsorship-toolkit/sponsorship-toolkit.component';
import { ContentModule } from '@tytapp/content';

@NgModule({
    declarations: [
        SettingsComponent,
        NotificationsSettingsComponent,
        NotificationsCategorySettingsComponent,
        AccountSettingsComponent,
        PrivacyControlsComponent,
        CommunicationPreferenceComponent,
        ChangeUsernameComponent,
        ChangeEmailComponent,
        ChangePasswordComponent,
        MembershipAccountComponent,
        MembershipFeatureComponent,
        MembershipFeaturesComponent,
        DeleteUserDataComponent,
        SponsorshipToolkitComponent
    ],
    providers: [
        CartService
    ],
    imports: [
        CommonModule,
        TYTCommonModule,
        CommonUiModule,
        RouterModule,
        UserModule,
        SocialModule,
        ShowsModule,
        DevModule,
        MatIconModule,
        MatButtonModule,
        MatSelectModule,
        MatTabsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatExpansionModule,
        MatButtonToggleModule,
        MatCheckboxModule,
        FormsModule,
        ContentModule,
        RouterModule.forChild([
            {
                path: 'delete-data',
                component: DeleteUserDataComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'sponsorship-toolkit-v1',
                component: SponsorshipToolkitComponent
            },
            {
                path: ':section/:subsection',
                component: SettingsComponent
            },
            {
                path: ':section',
                component: SettingsComponent
            },
            {
                path: '',
                pathMatch: 'full',
                component: SettingsComponent
            }
        ])
    ]
})
export class SettingsPagesModule {

}
